/*
 * fn: cleanInternalRedirect
 *
 * Ensures a redirect param is internal, or falls back to a fallback
 *
 */
export const cleanInternalRedirect = (redirect?: string | null) => {
  if (typeof window === 'undefined' || !redirect) return
  try {
    const url = new URL(redirect, window.location.origin)
    if (url.origin !== window.location.origin) return
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return
  }
}
